import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_IMAGE_OVERLAY__type_mismatch({ field }: PROPS) {
  /*
   * HTML
   */

  if (!field.image__is_initialized) return null;
  if (field.asset.is_single_color) return null; //single color could be everywhere
  if (field.is_category_any) return null; //any category is allowed
  if (field.category == field.asset.category) return null; //same category

  return <div className="absolute top-0 left-0 size-full flex-center bg-black-80 text-xs text-orange-500 pointer-events-none">Image type missmatch</div>;
}
